<div class="tam-contact-control" attr.tid="{{config.controlName}}">
    <kendo-dropdownlist [style.width.px]="childConfig.css.width" [popupSettings]="{appendTo: 'component'}"
        (valueChange)="valueChange($event)" [(ngModel)]="selectedItem" #dropDownEl [data]="suggestionItems"
        class="contact-dropdown" (focus)="dropDownEl.toggle(true)" (mousedown)="$event.preventDefault()">
    </kendo-dropdownlist>
    <div>
        <label [hidden]="!hintContent" class="item-label-error">
            {{hintContent}}
        </label>
    </div>
</div>